import React from 'react';

const Submitting = () => (
  <i className="fa fa-cog fa-spin" />
);

export default Submitting;



// WEBPACK FOOTER //
// ./src/features/shared/Submitting.jsx